module.exports = __webpack_public_path__ + "img/shopping-bag-hand-bag.e88e3a7f.svg";